import { huizongorder,kufanghuizongorder,tijiaoorder,zhipeishenhe,kufangshenhe,tongpeishenhe,shanchugoods,cancelOrder, tuihuiOrder,takeOrder, delOrder, payOrder } from "@api/order";
import dialog from "@utils/dialog";
import { pay } from "@libs/wechat";
import router from "../router";
export function kufanghuizongHandle() {
	 
  return new Promise((resolve, reject) => {
    dialog.confirm({
      mes: "确认汇总订单吗?",
      opts() {
		    dialog.message('正在汇总');
        kufanghuizongorder()
          .then(res => {
			  if(res.code==1){
				  
		 
			  console.log(res);
            dialog.success("汇总完成");
            resolve(res);
				  }else{
					  
					 dialog.error(res.message);  
					  
				  }
          })
          .catch(err => {
            dialog.error("汇总失败");
            reject(err);
          });
      }
    });
  });
}
export function huizongHandle() {
	 
  return new Promise((resolve, reject) => {
    dialog.confirm({
      mes: "确认汇总订单吗?",
      opts() {
		    dialog.message('正在汇总');
        huizongorder()
          .then(res => {
			  if(res.code==1){
				  
		  resolve(res);
			  console.log(res);
            dialog.success("汇总完成");
            
				  }else{
					  
					 dialog.error(res.message);  
					  
				  }
          })
          .catch(err => {
            dialog.error("汇总失败");
            reject(err);
          });
      }
    });
  });
}

export function tijiaoorerHandle(orderId) {
	 
  return new Promise((resolve, reject) => {
    dialog.confirm({
      mes: "确认重新提交该订单吗?",
      opts() {
        tijiaoorder(orderId)
          .then(res => {
            dialog.success("提交成功");
            resolve(res);
          })
          .catch(err => {
            dialog.error("提交失败");
            reject(err);
          });
      }
    });
  });
}
export function shanchuzhipeigoodsHandle(orderId) {
  return new Promise((resolve, reject) => {
    dialog.confirm({
      mes: "确认删除该商品?",
      opts() {
        shanchuzhipeigoods(orderId)
          .then(res => {
            dialog.success("删除成功");
            resolve(res);
          })
          .catch(err => {
            dialog.error("删除失败");
            reject(err);
          });
      }
    });
  });
}
export function shanchutongpeigoodsHandle(orderId) {
  return new Promise((resolve, reject) => {
    dialog.confirm({
      mes: "确认删除该商品?",
      opts() {
        shanchutongpeigoods(orderId)
          .then(res => {
            dialog.success("删除成功");
            resolve(res);
          })
          .catch(err => {
            dialog.error("删除失败");
            reject(err);
          });
      }
    });
  });
}
export function shanchugoodsHandle(orderId) {
  return new Promise((resolve, reject) => {
    dialog.confirm({
      mes: "确认删除该商品?",
      opts() {
        shanchugoods(orderId)
          .then(res => {
            dialog.success("删除成功");
            resolve(res);
          })
          .catch(err => {
            dialog.error("删除失败");
            reject(err);
          });
      }
    });
  });
}
export function zhipeishenheHandle(orderId) {
  return new Promise((resolve, reject) => {
    dialog.confirm({
      mes: "确认审核该订单?",
      opts() {
        zhipeishenhe(orderId)
          .then(res => {
            dialog.success("审核完成");
            resolve(res);
          })
          .catch(err => {
            dialog.error("审核失败");
            reject(err);
          });
      }
    });
  });
}
export function kufangshenheHandle(orderId) {
  return new Promise((resolve, reject) => {
    dialog.confirm({
      mes: "确认审核该订单?",
      opts() {
        kufangshenhe(orderId)
          .then(res => {
            dialog.success("审核完成");
            resolve(res);
          })
          .catch(err => {
            dialog.error("审核失败");
            reject(err);
          });
      }
    });
  });
}
export function tongpeishenheHandle(orderId) {
  return new Promise((resolve, reject) => {
    dialog.confirm({
      mes: "确认审核该订单?",
      opts() {
        tongpeishenhe(orderId)
          .then(res => {
            dialog.success("审核完成");
            resolve(res);
          })
          .catch(err => {
            dialog.error("审核失败");
            reject(err);
          });
      }
    });
  });
}
export function cancelOrderHandle(orderId) {
  return new Promise((resolve, reject) => {
    dialog.confirm({
      mes: "确认取消该订单?",
      opts() {
        cancelOrder(orderId)
          .then(res => {
            dialog.success("取消成功");
            resolve(res);
          })
          .catch(err => {
            dialog.error("取消失败");
            reject(err);
          });
      }
    });
  });
}
export function tuihuiOrderHandle(orderId,dm_id) {
  return new Promise((resolve, reject) => {
    dialog.confirm({
      mes: "确认退回该订单?",
      opts() {
        tuihuiOrder(orderId,dm_id)
          .then(res => {
            dialog.success("退回成功");
            resolve(res);
          })
          .catch(err => {
            dialog.error("退回失败");
            reject(err);
          });
      }
    });
  });
}

export function takeOrderHandle(orderId) {
  return new Promise((resolve, reject) => {
    takeOrder(orderId)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        dialog.error("收货失败");
        reject(err);
      });
  });
}

export function delOrderHandle(orderId) {
  return new Promise((resolve, reject) => {
    dialog.confirm({
      mes: "确认删除该订单?",
      opts() {
        delOrder(orderId)
          .then(res => {
            dialog.success("删除成功");
            resolve(res);
          })
          .catch(err => {
            dialog.error("删除失败");
            reject(err);
          });
      }
    });
  });
}

export function payOrderHandle(orderId, type, from) {
  return new Promise((resolve, reject) => {
    dialog.loading.open("");
    payOrder(orderId, type, from)
      .then(res => {
        const data = res.data;
        dialog.loading.close();
        switch (data.status) {
          case "WECHAT_H5_PAY":
            reject(data);
            setTimeout(() => {
              location.replace(data.result.jsConfig.mweb_url);
            }, 100);
            break;
          case "ORDER_EXIST":
          case "EXTEND_ORDER":
          case "PAY_ERROR":
          case "PAY_DEFICIENCY":
            dialog.toast({ mes: res.msg });
            reject(data);
            break;
          case "SUCCESS":
            dialog.success(res.msg);
            resolve(data);
            break;
          case "WECHAT_PAY":
            pay(data.result.jsConfig).then(() => {
              resolve(data);
            });
        }
      })
      .catch(err => {
        dialog.loading.close();
        dialog.toast({ mes: err.msg || "订单支付失败" });
      });
  });
}

export function goShopDetail(item) {
  return new Promise(resolve => {
    if (item.activity && item.activity.type === "1") {
      router.push({
        path:
          "/activity/seckill_detail/" +
          item.activity.id +
          "/" +
          item.activity.time +
          "/1"
      });
    } else if (item.activity && item.activity.type === "2") {
      router.push({
        path: "/activity/dargain_detail/" + item.activity.id
      });
    } else if (item.activity && item.activity.type === "3") {
      router.push({
        path: "/activity/group_detail/" + item.activity.id
      });
    } else {
      resolve(item);
    }
  });
}
